import { render, staticRenderFns } from "./reservationOrder.vue?vue&type=template&id=73308070&scoped=true&"
import script from "./reservationOrder.vue?vue&type=script&lang=js&"
export * from "./reservationOrder.vue?vue&type=script&lang=js&"
import style0 from "./reservationOrder.vue?vue&type=style&index=0&id=73308070&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73308070",
  null
  
)

export default component.exports